module.exports = __webpack_public_path__ + "assets/images/Feedback53270e9cc1082709b9c3e63853899616.svg";